import { useContext, useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import { MapFullScreenContext } from "./MapFullScreen";

// Split from `MapFullScreen.jsx` so a screen that only wraps a map in the
// full-screen box does not pull `react-leaflet` onto its import chain.

/**
 * Lives INSIDE the `MapContainer`. When the box changes (open or close) it
 * tells leaflet the size changed, then runs the caller's own fit again so
 * the view is framed for the new box. Renders nothing, and does nothing
 * when there is no `MapFullScreen` above it.
 */
export default function MapFullScreenSync({ onResized }) {
  const ctx = useContext(MapFullScreenContext);
  const map = useMap();
  const open = ctx ? ctx.open : false;
  // Fires on a real open/close only: not on mount while closed, and not on a
  // parent re-render that leaves `open` as it was.
  const lastOpen = useRef(open);
  const callback = useRef(onResized);
  callback.current = onResized;
  useEffect(() => {
    if (lastOpen.current === open) return;
    lastOpen.current = open;
    map.invalidateSize();
    if (callback.current) callback.current(map);
  }, [map, open]);
  return null;
}
